gloGreenTL = gsap.timeline();
gloGreenTL
.from('.animate-background-cactus-patch', { duration: 2, opacity: 0, ease: "power1.in"})
.from('.animate-brose', { duration: 1, opacity: 0, ease: "power1.in"})
.to('.animate-brose', { duration: 3, y: 20, ease: "power1.inOut", yoyo: true, repeat: -1});